import { Injectable, Inject } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";

import { Constants } from "../../shared/Constants";
import { Observable } from "rxjs";

@Injectable()
export class MedioEntregablesService {
  constructor(private http: HttpClient) {}

  getAll(): Observable<any[]> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );
    return this.http.get<any[]>(
      Constants.URL_BACKEND + "/medio-entregables",
      { headers: headers }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/system/services/medio_entregables.service.ts